<template>
  <div class="home-container">
    <div id="map" class="map"></div>
    <canvas ref="rainCanvas" class="rain-canvas"></canvas>
    
    
    <!-- 温度：左上角大字 -->
    <div class="temp-display" :style="{ top: warningData.headline ? '44px' : '10px' }">{{ weatherData.temperature }}℃</div>

    <!-- 紧贴顶部全宽飘动云层 -->
    <div class="cloud-wrap">
      <img src="@/assets/cluod.png" class="cloud-img" alt="" />
      <img src="@/assets/cluod.png" class="cloud-img" alt="" />
    </div>

    <!-- 右上角太阳 -->
    <img v-if="!hasRain" src="@/assets/sun2.gif" class="sun-gif" alt="" />

    <!-- 城市名：右上角小标签 -->
    <!-- <div class="city-tag" :style="{ top: warningData.headline ? '46px' : '12px' }">{{ weatherData.name || '都江堰' }}</div> -->

    <!-- 三项指标：左侧竖向排列的独立卡片 -->
    <div class="info-chips" :style="{ top: warningData.headline ? '92px' : '58px' }">
      <div class="info-chip">
        <span class="chip-label">体感</span>
        <span class="chip-val">{{ weatherData.feelst }}℃</span>
      </div>
      <div class="info-chip">
        <span class="chip-label">湿度</span>
        <span class="chip-val">{{ weatherData.humidity }}%</span>
      </div>
      <div class="info-chip">
        <span class="chip-label">降水</span>
        <span class="chip-val">{{ weatherData.precipitation }}mm</span>
      </div>
    </div>
    <!-- <div class="side-btns">
      <div class="side-btn">实景</div>
      <div class="side-btn">预报</div>
    </div> -->

    <!-- 预警信息：有预警时显示在温度下方 -->
    <div v-if="warningData.headline" class="warning-bar" :class="'severity-' + warningData.severity.toLowerCase()" @click="showWarningDetail = true">
      <div class="warning-header">
        <span class="warning-icon">⚠</span>
        <span class="warning-title">{{ warningData.headline }}</span>
      </div>
      <div class="warning-desc">预警详情</div>
    </div>

    <!-- 预警详情弹窗 -->
    <div v-if="showWarningDetail" class="warning-modal-mask" @click="showWarningDetail = false">
      <div class="warning-modal" @click.stop>
        <div class="warning-modal-severity" :class="'severity-' + warningData.severity.toLowerCase()">
          <span class="warning-modal-badge">⚠ {{ warningData.severity === 'Red' ? '红色预警' : warningData.severity === 'Orange' ? '橙色预警' : warningData.severity === 'Yellow' ? '黄色预警' : warningData.severity === 'Blue' ? '蓝色预警' : '预警' }}</span>
        </div>
        <div class="warning-modal-title">{{ warningData.headline }}</div>
        <div class="warning-modal-body">{{ warningData.description }}</div>
        <div class="warning-modal-close" @click="showWarningDetail = false">关闭</div>
      </div>
    </div>
    <div v-if="forecastList.length" class="forecast-bar">
      <div class="forecast-bar-title">{{ currentStation }} 未来预报</div>
      <div class="forecast-scroll">
        <div
          v-for="(f, i) in forecastList"
          :key="i"
          class="forecast-item"
        >
          <div class="fc-date">{{ f.forecastDate.slice(5) }}</div>
          <div class="fc-weather">{{ f.dayWeather }}</div>
          <div class="fc-temps">
            <span class="fc-max">{{ f.maxTmp }}℃</span>
            <span class="fc-min">{{ f.minTmp }}℃</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权 -->
    <div class="copyright" :style="{ bottom: forecastList.length ? '70px' : '8px' }">
      数据来源&版权所有：都江堰市气象局
    </div>

  </div>
</template>

<script>
import L from "leaflet";
import mapImg from "@/assets/map4.png";
import makerIcon from "@/assets/maker.png";
export default {
  name: "HomeView",
  components: {
  },
  data() {
    return {
      map: null,
      latlng: null,
      markerPosList: [],
      loading: true,
      forecastList: [],
      currentStation: '',
      weatherData: {
        temperature: '--',
        feelst: '--',
        humidity: '--',
        precipitation: '--',
        name: '',
      },
      warningData: {
        headline: '',
        description: '',
        severity: '',
      },
      showWarningDetail: false,
    };
  },
  async mounted() {
    await Promise.all([this.fetchWeather(), this.fetchMyFell(), this.fetchWarning()]);
    this.initMap();
    this.initRain();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    if (this._rainId) {
      cancelAnimationFrame(this._rainId);
      this._rainId = null;
    }
  },
  computed: {
    hasRain() {
      const p = parseFloat(this.weatherData.precipitation)
      return !isNaN(p) && p > 0
    },
  },
  methods: {
    async fetchWeather() {
      const STATIC_POS = {
        '虹口花谷': [541.0892373262382, 162.9213747553728],
        // '虹口': [349, 42],
        '虹口': [ 345.3280936480294, 68.39291699467613],
        '茶溪谷': [250.66668701171875, 193.33334350585938],
        '都江堰景区': [11.49224245442675, -101.74844058357742],
        '熊猫谷': [-31.666717529296875, -258.6665954589844],
        '灌县古城': [ 41.203924347432014, 46.66904755831214],
        '成都融创文旅城': [-155.09212400313578, -113.1371094132388],
        '青城前山': [ -250.92270126557415, -203.35441666546532],
        // '青城山': [-123.52101605925147, -244.61009985578636],
        '青城后山': [-278.6000717874997, -407.29350596345137],
        '问花村': [ -637.8103166302658, -94.04520189781081],
      };
      try {
        const res = await fetch('https://www.moodsci.com/Backend/hfive/stationData/getStationMessage');
        const json = await res.json();
        if (json.code === 200 && json.data?.message) {
          this.markerPosList = json.data.message
            .filter(item => STATIC_POS[item.stationName])
            .map(item => ({
              name: item.stationName,
              pos: STATIC_POS[item.stationName],
              temp: item.temperature,
              humidity: item.humidity + '%',
              wind: item.windDirect + ' ' + item.windSpeed,
            }));
        }
      } catch (e) {
        console.error('获取天气数据失败', e);
      } finally {
        this.loading = false;
      }
    },
    async fetchMyFell() {
      try {
        const res = await fetch('https://www.moodsci.com/Backend/hfive/stationData/getMyFell');
        const json = await res.json();
        if (json.code === 200 && json.data) {
          this.weatherData = {
            temperature: json.data.temperature,
            feelst: json.data.feelst,
            humidity: json.data.humidity,
            precipitation: json.data.precipitation,
            name: json.data.name,
          };
        }
      } catch (e) {
        console.error('获取天气概况失败', e);
      }
    },
    async fetchWarning() {
      try {
        const res = await fetch('https://www.moodsci.com/Backend/hfive/stationData/warningInformation');
        const json = await res.json();
        if (json.code === 200 && json.data) {
          this.warningData = {
            headline: json.data.headline,
            description: json.data.description,
            severity: json.data.severity,
          };
        }
      } catch (e) {
        console.error('获取预警信息失败', e);
      }
    },
    async fetchForecast(stationName) {
      this.currentStation = stationName;
      this.forecastList = [];
      try {
        const res = await fetch(`https://www.moodsci.com/Backend/hfive/stationData/forcastStation?stationName=${encodeURIComponent(stationName)}`);
        const json = await res.json();
        if (json.code === 200 && json.data) {
          this.forecastList = json.data;
        }
      } catch (e) {
        console.error('获取预报失败', e);
      }
    },
    initMap() {
      // 使用简单坐标系（无底图时推荐）
      const imgBounds = [
        [-959.5, -540],
        [959.5, 540],
      ];

      this.map = L.map("map", {
        crs: L.CRS.Simple,
        center: [200, -100],
        minZoom: -5,
        maxZoom: 5,
        zoomSnap: 0.25,
        zoomDelta: 0.5,
        zoom: -1.25,
        zoomControl: false,
        zoomControlPosition: "bottomright",
        attributionControl: false,
        dragging: true,
        touchZoom: true,
        scrollWheelZoom: true,
        doubleClickZoom: false,
      });

      // 叠加 assets 中的图片（3921×6966）
      L.imageOverlay(mapImg, imgBounds).addTo(this.map);

      this.map.setMaxBounds(imgBounds);

      this.map.on('popupclose', () => {
        this.forecastList = [];
        this.currentStation = '';
      });

      // 渲染 markerPosList 中所有标记点
      this.markerPosList.forEach((item) => {
        const [lng, lat] = item.pos
        const html = `<div style="background:rgba(0, 186, 186,0.8);color:#fff;font-size:11px;font-weight:600;padding:2px 8px;border-radius:10px;white-space:nowrap;box-shadow:0 1px 3px rgba(0,0,0,0.3);display:flex;align-items:center;gap:4px;"><img src="${makerIcon}" style="width:18px;height:18px;flex-shrink:0;"/>${item.name} ${item.temp}℃ ${item.humidity}</div>`
        const icon = L.divIcon({
          className: 'poi-marker',
          html,
          iconSize: [0, 0],
          iconAnchor: [0, 0],
        })

        const marker = L.marker([lng, lat], { icon }).addTo(this.map)

        marker.on('click', () => {
          this.fetchForecast(item.name)
          const container = L.DomUtil.create('div')
          container.style.minWidth = '160px'
          container.style.fontSize = '11px'
          container.style.color = '#333'
          container.innerHTML = `
            <div style="text-align:center;margin-bottom:6px;">
              <div style="font-size:13px;font-weight:700;color:#222;">${item.name}</div>
              <div style="font-size:24px;font-weight:200;color:#333;line-height:1.1;">${item.temp}℃</div>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:2px 8px;border-top:1px solid #eee;padding-top:6px;">
              <div style="color:#999;">湿度</div><div style="text-align:right;">${item.humidity}</div>
              <div style="color:#999;">风力</div><div style="text-align:right;">${item.wind}</div>
            </div>`

          L.popup({ maxWidth: 200, className: 'weather-popup' })
            .setLatLng([lng, lat])
            .setContent(container)
            .openOn(this.map)
        })
      })

      // 点击获取坐标
      this.map.on("click", (e) => {
        console.log(e.latlng);

        const { lng, lat } = e.latlng;
        this.latlng = { lng: Math.round(lng), lat: Math.round(lat) };
        console.log(`点击坐标: X=${Math.round(lng)}, Y=${Math.round(lat)}`);
      });
    },

    initRain() {
      const precip = parseFloat(this.weatherData.precipitation) || 0
      const intensity = precip <= 0.1 ? 0 : precip <= 5 ? 1 : precip <= 15 ? 2 : 3

      // 降水 ≤ 0.1mm 不显示雨滴
      if (intensity === 0) return

      const canvas = this.$refs.rainCanvas
      const ctx = canvas.getContext('2d')

      let drops = []
      const DROP_COUNT = [0, 100, 200, 280][intensity]
      const heavyRatio = [0, 0.1, 0.2, 0.35][intensity]

      const resize = () => {
        canvas.width = window.innerWidth
        canvas.height = window.innerHeight
      }

      const createDrop = (heavy) => {
        const speedMul = 0.6 + intensity * 0.4
        const baseSpeed = heavy
          ? 14 + Math.random() * 12
          : 4 + Math.random() * 10
        return {
          x: Math.random() * canvas.width * 1.6 - canvas.width * 0.3,
          y: Math.random() * -canvas.height * 1.2,
          len: heavy ? 20 + Math.random() * 30 : 8 + Math.random() * 18,
          speed: baseSpeed * speedMul,
          wind: 1.5 + Math.random() * 2.5,
          opacity: heavy ? 0.5 + Math.random() * 0.3 : 0.15 + Math.random() * 0.3,
          width: heavy ? 1.2 + Math.random() * 0.8 : 0.4 + Math.random() * 0.6,
          trail: heavy && Math.random() > 0.5,
        }
      }

      resize()
      const heavyCount = Math.round(DROP_COUNT * heavyRatio)
      const lightCount = DROP_COUNT - heavyCount
      const heavyDrops = Array.from({ length: heavyCount }, () => createDrop(true))
      const lightDrops = Array.from({ length: lightCount }, () => createDrop(false))
      drops = [...heavyDrops, ...lightDrops]
      window.addEventListener('resize', resize)

      const draw = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        for (let i = 0; i < drops.length; i++) {
          const d = drops[i]

          ctx.beginPath()
          ctx.moveTo(d.x, d.y)
          ctx.lineTo(d.x - d.wind, d.y - d.len)

          // 拖尾效果
          if (d.trail) {
            const grad = ctx.createLinearGradient(d.x, d.y, d.x - d.wind, d.y - d.len)
            grad.addColorStop(0, `rgba(180, 215, 255, ${d.opacity * 0.3})`)
            grad.addColorStop(0.3, `rgba(190, 220, 255, ${d.opacity * 0.7})`)
            grad.addColorStop(1, `rgba(200, 230, 255, ${d.opacity})`)
            ctx.strokeStyle = grad
          } else {
            ctx.strokeStyle = `rgba(200, 225, 255, ${d.opacity})`
          }

          ctx.lineWidth = d.width
          ctx.shadowColor = `rgba(180, 220, 255, ${d.opacity * 0.4})`
          ctx.shadowBlur = d.width * 1.5
          ctx.stroke()

          d.y += d.speed
          if (d.y > canvas.height + d.len) {
            d.y = -d.len - Math.random() * 100
            d.x = Math.random() * canvas.width * 1.6 - canvas.width * 0.3
          }
        }

        ctx.shadowBlur = 0
        this._rainId = requestAnimationFrame(draw)
      }
      draw()
    },
  },
};
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100vh;
  position: relative;
}

.map {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #d4e9f7 0%, #a8d4e6 25%, #7ac0d8 50%, #5ba3be 75%, #4a8eaa 100%);
  position: relative;
  z-index: 1;
}

.coords-panel {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
}
.temp-display {
  position: absolute;
  left: 10px;
  font-size: 42px;
  font-weight: 200;
  color: #1a1a2e;
  line-height: 1;
  z-index: 20;
  text-shadow: 0 1px 8px rgba(255, 255, 255, 0.5);
}

.sun-gif {
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  width: 200px;
  height: auto;
  z-index: 19;
  pointer-events: none;
}

.cloud-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  z-index: 18;
  overflow: hidden;
  pointer-events: none;
}

.cloud-img {
  position: absolute;
  top: 0;
  height: 150px;
  width: 100%;
  object-fit: cover;
  animation: cloud-drift 20s linear infinite;
}

.cloud-img + .cloud-img {
  animation: cloud-drift-2 20s linear infinite;
}

@keyframes cloud-drift {
  0%   { left: 0; }
  100% { left: -100%; }
}

@keyframes cloud-drift-2 {
  0%   { left: 100%; }
  100% { left: 0; }
}

.city-tag {
  position: absolute;
  right: 10px;
  padding: 4px 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #fff;
  font-size: 12px;
  z-index: 20;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.info-chips {
  position: absolute;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 20;
}

.info-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.chip-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.85);
  min-width: 24px;
}

.chip-val {
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.side-btns {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 20;
}

.side-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(0, 110, 255, 0.5);
  backdrop-filter: blur(8px);
  border: 1px solid rgb(250, 250, 250);
  -webkit-backdrop-filter: blur(8px);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  /* border: 1px solid rgba(255, 255, 255, 0.15); */
  letter-spacing: 1px;
}

.rain-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  mix-blend-mode: screen;
}

.forecast-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 30;
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.forecast-bar-title {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.forecast-scroll {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.forecast-scroll::-webkit-scrollbar {
  display: none;
}

.forecast-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 56px;
  color: #fff;
}

.fc-date {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.6);
}

.fc-weather {
  font-size: 12px;
}

.fc-temps {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  line-height: 1.3;
}

.fc-max {
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}

.fc-min {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.5);
}

.copyright {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  z-index: 15;
  pointer-events: none;
}

.warning-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 8px 12px;
  z-index: 25;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.warning-bar.severity-red {
  background: rgba(220, 38, 38, 0.6);
  border: 1px solid rgba(239, 68, 68, 0.8);
}

.warning-bar.severity-orange {
  background: rgba(234, 88, 12, 0.6);
  border: 1px solid rgba(249, 115, 22, 0.8);
}

.warning-bar.severity-yellow {
  background: rgba(202, 138, 4, 0.6);
  border: 1px solid rgba(234, 179, 8, 0.8);
}

.warning-bar.severity-blue {
  background: rgba(37, 99, 235, 0.6);
  border: 1px solid rgba(59, 130, 246, 0.8);
}

.warning-header {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  overflow: hidden;
}

.warning-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.warning-title {
  font-size: 12px;
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.warning-desc {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;
  margin-left: 8px;
}

.warning-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-modal {
  width: 85vw;
  max-width: 340px;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.warning-modal-severity {
  padding: 10px 16px;
  text-align: center;
}

.warning-modal-severity.severity-red {
  background: #dc2626;
}

.warning-modal-severity.severity-orange {
  background: #ea580c;
}

.warning-modal-severity.severity-yellow {
  background: #ca8a04;
}

.warning-modal-severity.severity-blue {
  background: #2563eb;
}

.warning-modal-badge {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.warning-modal-title {
  padding: 12px 16px 4px;
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.warning-modal-body {
  padding: 8px 16px 20px;
  font-size: 13px;
  color: #555;
  line-height: 1.7;
}

.warning-modal-close {
  padding: 12px;
  text-align: center;
  font-size: 14px;
  color: #999;
  border-top: 1px solid #eee;
  cursor: pointer;
}
</style>

<style>
.poi-marker {
  width: auto !important;
  height: auto !important;
  background: transparent !important;
  border: none !important;
  /* transform: translate(-50%, -50%); */
}
.weather-popup .leaflet-popup-content-wrapper {
  border-radius: 12px;
  padding: 4px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}
.weather-popup .leaflet-popup-tip {
  background: rgba(255, 255, 255, 0.95);
}
.weather-popup .leaflet-popup-close-button {
  font-size: 16px;
  color: #999 !important;
}
</style>
